import { render, staticRenderFns } from "./approvedProviders.vue?vue&type=template&id=3fbb3c25"
import script from "./approvedProviders.vue?vue&type=script&lang=js"
export * from "./approvedProviders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports